import i18n from '@/plugins/i18n';

export default {
  E_102: {
    message: i18n.t('error.passWrong'),
  },
  E_103: {
    message: i18n.t('error.namesakeCategory'),
  },
  E_104: {
    message: i18n.t('error.namesake'),
  },
};
